import { MenuSelectOption } from '@equip.health/ui';

export const pageCount: MenuSelectOption[] = [
  {
    node: '10 results',
    value: '10',
  },
  {
    node: '25 results',
    value: '25',
  },
  {
    node: '50 results',
    value: '50',
  },
  {
    node: '100 results',
    value: '100',
  },
];
